// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"error_errorWrapper__2_jQM","error":"error_error__32KdL","info":"error_info__20G3g"};